import { render } from "./imageAndQuestions.vue?vue&type=template&id=3a211480&scoped=true&ts=true"
import script from "./imageAndQuestions.vue?vue&type=script&lang=ts"
export * from "./imageAndQuestions.vue?vue&type=script&lang=ts"

import "./imageAndQuestions.vue?vue&type=style&index=0&id=3a211480&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a211480"]])

export default __exports__